export {
  postToWorker,
  requestWorker,
  terminateSymbolIndexWorker,
  resetSymbolIndexWorkerLifecycleForTests,
} from './lifecycle/index.js';
